export default __webpack_public_path__ + "static/media/olympiastadion.a7817964.jpg";